module.exports = __webpack_public_path__ + "img/__icon_JUMBO.cc83ea76.svg";